import _ from 'lodash';
import moment from 'moment';

function formatNumber(num) {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

function convertToMbps(kbps) {
  const mbps = (kbps / 1000);
  return formatNumber(mbps.toFixed(1));
}

function getPercentiles(percentiles, number) {
  const percentile = _.find(percentiles, item => item.key === number);
  return parseFloat(convertToMbps((percentile.value).toFixed(1)));
}

function convertFormatDate(date) {
  return moment(date).format('YYYYMMDD');
}

function convertDateToMonth(date) {
  return moment(date, 'YYYYMMDD').format('YYYYMM');
}

function calSampleSize(data) {
  return formatNumber(_.sumBy(data, 'count'));
}

export {
  getPercentiles,
  convertToMbps,
  formatNumber,
  convertFormatDate,
  convertDateToMonth,
  calSampleSize,
};



// WEBPACK FOOTER //
// ./src/modules/utility.js